import React from 'react'

import { Avatar as ChakraAvatar } from '@chakra-ui/react'
const Avatar = ({ ...props }) => {
    return <ChakraAvatar bg="gray.200" color="gray.500" {...props} />
}
export default Avatar
